export default __webpack_public_path__ + "static/media/downloadWallet.2317e3dd.svg";